import {
  GETFEEMANAGEMENTLIST_SUCCESS,
  GETFEEMANAGEMENTLIST_FAILED,
  RESET_GETFEEMANAGEMENTLIST,
  LOADING_GETFEEMANAGEMENTLIST,
  NETWORK_ERROR_GETFEEMANAGEMENTLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETFEEMANAGEMENTLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETFEEMANAGEMENTLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETFEEMANAGEMENTLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETFEEMANAGEMENTLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETFEEMANAGEMENTLIST:
      return (state = initialState);
    default:
      return state;
  }
};
